// Shared try/catch wrapper behind localStorage/sessionStorage — both throw in
// privacy modes, SSR-like environments, and disabled-storage settings, and
// every caller here degrades the same way: forget a remembered choice,
// re-derive it next time, or simply lose a one-shot signal. Callers that need
// observable failure should not use this.
export interface SafeStorage {
  read(key: string): string | null
  write(key: string, value: string): void
  remove(key: string): void
}

// Takes a getter, not the Storage object: some browsers throw merely
// accessing window.localStorage/sessionStorage, so access must happen
// INSIDE the try/catch on every call — never cached at module-load time.
export const createSafeStorage = (getStorage: () => Storage): SafeStorage => ({
  read: (key) => {
    try {
      return getStorage().getItem(key)
    } catch {
      return null
    }
  },
  write: (key, value) => {
    try {
      getStorage().setItem(key, value)
    } catch {
      // Best-effort.
    }
  },
  remove: (key) => {
    try {
      getStorage().removeItem(key)
    } catch {
      // Best-effort.
    }
  },
})
